import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getApprovedWorkOrderCount = createAsyncThunk(
  '/getApprovedWorkOrderSummary',
  async () => {
    const response = await axios.get('/GetApprovedWorkOrderSummary');
    return response.data;
  }
);

export const closePeriod = createAsyncThunk(
  '/closePeriod',
  async (periodData) => {
    const response = await axios.post('/ClosePeriod', periodData);
    return response.data;
  }
);

export const distributeBonus = createAsyncThunk(
  '/distributeBonus',
  async () => {
    const response = await axios.post('/DistributeBonus');
    return response.data;
  }
);

export const sendInvoices = createAsyncThunk(
  '/sendInvoices',
  async () => {
    const response = await axios.post('/SendInvoices');
    return response.data;
  }
);

export const getAccountingReports = createAsyncThunk(
  '/getAccountingReports',
  async () => {
    const response = await axios.get('/GetAccountingReports');
    return response.data;
  }
);

const accountingFinalOperationsSlice = createSlice({
  name: 'accountingFinalOperations',
  initialState: {
    loading: false,
    error: '',
    workOrderCount: 0,
    pendingInvoiceMailsCount: 0,
    isDistributeBonusDisabled: false,
    isSendInvoicesDisabled: false,
    latestBonus: {
      year: 0,
      month: 0
    },
    reports: [],
    responses: {
      closePeriod: null,
      distributeBonus: null,
      sendInvoices: null,
    },
  },
  reducers: {
    resetResponses(state) {
      state.responses = {
        closePeriod: null,
        distributeBonus: null,
        sendInvoices: null,
      };
    },
  },
  extraReducers: {
    [getApprovedWorkOrderCount.pending]: (state) => {
      state.loading = true;
    },
    [getApprovedWorkOrderCount.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [getApprovedWorkOrderCount.fulfilled]: (state, action) => {
      state.loading = false;
      state.workOrderCount = action.payload.ApprovedWorkOrderCount;
      state.pendingInvoiceMailsCount = action.payload.PendingInvoiceMailsCount;
      state.isDistributeBonusDisabled = action.payload.IsDistributeBonusDisabled;
      state.isSendInvoicesDisabled = action.payload.IsSendInvoicesDisabled;
      state.latestBonus = {
        year: action.payload.LatestBonusYear,
        month: action.payload.LatestBonusMonth
      };
    },
    [getAccountingReports.pending]: (state) => {
      state.loading = true;
    },
    [getAccountingReports.fulfilled]: (state, action) => {
      state.loading = false;
      state.reports = action.payload;
    },
    [getAccountingReports.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [closePeriod.pending]: (state) => {
      state.loading = true;
    },
    [closePeriod.fulfilled]: (state, action) => {
      state.loading = false;
      state.responses.closePeriod = action.payload;
    },
    [closePeriod.rejected]: (state) => {
      state.loading = false;
    },
    [distributeBonus.pending]: (state) => {
      state.loading = true;
    },
    [distributeBonus.fulfilled]: (state, action) => {
      state.loading = false;
      state.responses.distributeBonus = action.payload;
    },
    [distributeBonus.rejected]: (state) => {
      state.loading = false;
    },
    [sendInvoices.pending]: (state) => {
      state.loading = true;
    },
    [sendInvoices.fulfilled]: (state, action) => {
      state.loading = false;
      state.responses.sendInvoices = action.payload;
    },
    [sendInvoices.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { resetResponses } = accountingFinalOperationsSlice.actions;

export default accountingFinalOperationsSlice;
